import { computed, defineComponent, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { FiscalYearAction, FiscalYearGetter } from '@/store/fiscalYear/fiscalYear.module';
import { FiscalYear } from '@/store/fiscalYear/fiscalYear.model';
import ProjectSummaryComponent from '@/components/project/main/projectSummary/ProjectSummary.vue';
import ResultResponseComponent from '@/components/resultResponse/ResultResponse.vue';
import ResultProjectTypeComponent from '@/components/resultProjectType/ResultProjectType.vue';

export default defineComponent({
  name: 'ResultOfficerPage',
  components: {
    ProjectSummaryComponent,
    ResultResponseComponent,
    ResultProjectTypeComponent,
  },
  setup: () => {
    const store = useStore();
    const fiscalYears = computed<FiscalYear[]>(() => (store.getters[FiscalYearGetter.ALL] as FiscalYear[]).filter((m) => m.status <= 0));
    const selectedFiscalYear = ref<FiscalYear>();

    onMounted(() => {
      store.dispatch(FiscalYearAction.FETCH)
        .then(() => selectedFiscalYear.value = fiscalYears.value[0]);
    });

    return {
      fiscalYears,
      selectedFiscalYear,
    };
  }
});
